import { render, staticRenderFns } from "./dayview.vue?vue&type=template&id=2840122f&scoped=true&"
import script from "./dayview.vue?vue&type=script&lang=js&"
export * from "./dayview.vue?vue&type=script&lang=js&"
import style0 from "./dayview.vue?vue&type=style&index=0&id=2840122f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2840122f",
  null
  
)

export default component.exports